/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var CookieHub = /** @class */ (function () {
        function CookieHub() {
        }
        CookieHub.check = function () {
            var _a;
            var ch = (_a = window['cookiehub'], (_a !== null && _a !== void 0 ? _a : null));
            if (ch === null) {
                return false;
            }
            // @ts-ignore
            return !!ch.hasConsented('analytics');
        };
        return CookieHub;
    }());

    var CartAdd = /** @class */ (function () {
        function CartAdd(data) {
            this.data = data;
        }
        CartAdd.prototype.run = function () {
            if (CookieHub.check()) {
                this.trackCartAdd();
            }
        };
        CartAdd.prototype.trackCartAdd = function () {
            fbq('track', 'AddToCart', {
                content_name: this.data.itemLabel,
                content_category: this.data.categoryLabel,
                content_ids: this.getIds(),
                content_type: this.getContentType(),
                value: this.data.price,
                currency: 'ISK',
            });
        };
        CartAdd.prototype.getIds = function () {
            var variantSelection = document.querySelector('.storeProductView .storeVariantSelection');
            if (!variantSelection) {
                return document.querySelector('.storeReference .value').innerHTML;
            }
            var ret = [];
            variantSelection.querySelectorAll('.variant-selection-info .variant').forEach(function (variant) {
                ret.push(variant.getAttribute('data-reference'));
            });
            return ret;
        };
        CartAdd.prototype.getContentType = function () {
            var variantSelection = document.querySelector('.storeProductView .storeVariantSelection');
            if (variantSelection) {
                return 'product_group';
            }
            return 'product';
        };
        return CartAdd;
    }());
    MoyaEventHandler.on('store.cartAdd', function (data) {
        var cartAdd = new CartAdd(data.data);
        cartAdd.run();
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
